import { Link } from 'react-router-dom';
import WhatsAppButton from '../../common/whatsapp';
export default function TermsOfService() {
    const sections = [
        {
            title: '1. Acceptance of Terms',
            items: [
                'By using this website, you acknowledge that you have read, understood, and agreed to these Terms of Service.',
                'If you do not agree with any part of these terms, please do not use our website or services.',
            ],
        },
        {
            title: '2. Products and Services',
            items: [
                'Kinetix manufactures and supplies occupational therapy equipment, physiotherapy products, rehabilitation tools, sensory integration equipment, medical simulation mannequins, disposable training models, and related products.',
                'Product availability may change without prior notice.',
                'We reserve the right to modify, discontinue, or update products and services at any time.',
            ],
        },
        {
            title: '3. Product Information',
            items: [
                'We strive to ensure that product descriptions, specifications, dimensions, and images are accurate.',
                'Minor variations in color, dimensions, finish, or appearance may occur due to manufacturing processes.',
                'Product images are provided for illustrative purposes and may differ slightly from the delivered product.',
            ],
        },
        {
            title: '4. Orders and Acceptance',
            items: [
                'All orders are subject to acceptance and availability.',
                'Kinetix reserves the right to refuse or cancel any order at its discretion.',
                'An order is considered confirmed only after payment requirements have been fulfilled and official confirmation has been provided.',
            ],
        },
        {
            title: '5. Pricing',
            items: [
                'All prices are subject to change without prior notice.',
                'Prices displayed on the website may not include shipping charges, taxes, duties, or other applicable fees unless stated otherwise.',
                'Pricing errors may be corrected without liability.',
            ],
        },
        {
            title: '6. Payment Terms',
            items: [
                'Payment must be completed according to the agreed payment method and schedule.',
                'Custom and bulk manufacturing orders may require advance payment before production begins.',
                'Failure to complete payment may result in order cancellation or delay.',
            ],
        },
        {
            title: '7. Custom Manufacturing',
            items: [
                'Customers are responsible for reviewing and approving all custom specifications before production.',
                'Changes requested after production has started may result in additional charges and extended delivery times.',
                'Customized products are generally non-refundable unless a manufacturing defect is confirmed.',
            ],
        },
        {
            title: '8. Shipping and Delivery',
            items: [
                'Delivery timelines are estimates and may vary depending on production schedules, customization requirements, and shipping conditions.',
                'Kinetix is not responsible for delays caused by third-party courier services, customs procedures, natural disasters, or other events beyond our control.',
                'Risk of loss transfers to the customer upon delivery.',
            ],
        },
        {
            title: '9. Returns and Replacements',
            items: [
                'Customers should inspect products upon receipt.',
                'Claims for defects, damage, or shortages must be reported within the specified return period.',
                'Approved claims may be resolved through repair, replacement, or refund at our discretion.',
                'Products damaged through misuse, improper handling, or unauthorized modification are not eligible for return.',
            ],
        },
        {
            title: '10. Warranty',
            items: [
                'Warranty coverage applies only where explicitly stated.',
                'Warranty covers manufacturing defects under normal use conditions.',
                'Warranty does not cover accidental damage, misuse, improper installation, unauthorized repairs, or normal wear and tear.',
            ],
        },
        {
            title: '11. Intellectual Property',
            items: [
                'All website content, product designs, logos, graphics, text, images, and branding are the property of Kinetix unless otherwise stated.',
                'Unauthorized copying, reproduction, distribution, or commercial use is prohibited without written permission.',
            ],
        },
        {
            title: '12. Website Usage',
            items: [
                'Users agree to use the website lawfully and responsibly.',
                'Any attempt to disrupt website operations, gain unauthorized access, or misuse website content is strictly prohibited.',
                'We reserve the right to restrict access to users who violate these terms.',
            ],
        },
        {
            title: '13. Limitation of Liability',
            items: [
                'Kinetix shall not be liable for indirect, incidental, consequential, or special damages arising from the use of our products, services, or website.',
                'Our total liability shall not exceed the amount paid for the specific product or service involved.',
            ],
        },
        {
            title: '14. Product Use and Safety',
            items: [
                'Users are responsible for ensuring products are used correctly and safely.',
                'Therapy and rehabilitation equipment should be used under appropriate supervision where necessary.',
                'Medical training products are intended for educational and simulation purposes only unless otherwise specified.',
            ],
        },
        {
            title: '15. Third-Party Links',
            items: [
                'Our website may contain links to third-party websites for informational purposes.',
                'Kinetix is not responsible for the content, policies, or practices of external websites.',
            ],
        },
        {
            title: '16. Privacy',
            items: [
                'Use of our website is also governed by our Privacy Policy.',
                'By using our services, you consent to the collection and use of information as described in our Privacy Policy.',
            ],
        },
        {
            title: '17. Changes to Terms',
            items: [
                'Kinetix reserves the right to update or modify these Terms of Service at any time.',
                'Continued use of the website after updates constitutes acceptance of the revised terms.',
            ],
        },
        {
            title: '18. Governing Law',
            items: [
                'These Terms of Service shall be governed and interpreted in accordance with the laws of Pakistan.',
                'Any disputes arising from the use of our website, products, or services shall be subject to the jurisdiction of the courts of Pakistan.',
            ],
        },
        {
            title: '19. Contact Information',
            items: [
                'For questions regarding these Terms of Service, please contact Kinetix through our website, email, or customer support channels.',
            ],
        },
    ];

    return (
        <main className="pt-24">
            <WhatsAppButton />
            {/* Hero Section – dark blue bg */}
            <section className="w-full bg-[#15415c] py-16 md:py-20">
                <div className="max-w-4xl mx-auto px-6 text-center">
                    <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight leading-tight">
                        Terms of Service
                    </h1>
                    <p className="mt-2 text-sm md:text-base text-white/70 font-medium">
                        Last Updated: June 2026
                    </p>
                    <p className="mt-4 text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
                        By accessing our website, placing an order, or using our products and services, you agree to the following Terms of Service.
                    </p>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-16 md:py-24 bg-surface">
                <div className="max-w-4xl mx-auto px-6">
                    <div className="space-y-10">
                        {sections.map((section, idx) => (
                            <div key={idx}>
                                <h2 className="text-2xl md:text-3xl font-extrabold text-on-surface mb-3">
                                    {section.title}
                                </h2>
                                <ul className="list-disc pl-6 space-y-1.5 text-on-surface-variant leading-relaxed">
                                    {section.items.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>
                                {idx < sections.length - 1 && (
                                    <div className="h-px bg-surface-container-high mt-6" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    );
}